/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RequisitoStato } from './requisito-stato';


export interface RequisitoDTO { 
    area?: RequisitoDTOAreaEnum;
    code?: string;
    stato?: RequisitoStato;
    obbligatorio?: boolean;
    params?: Array<any>;
    pointer?: string;
    congelato?: boolean;
}
export enum RequisitoDTOAreaEnum {
    POLICY = 'POLICY',
    ATTRIBUTI = 'ATTRIBUTI',
    TEMPLATE = 'TEMPLATE',
    SCORING = 'SCORING',
    GRADUATORIA = 'GRADUATORIA',
    SERVIZIO = 'SERVIZIO'
};



